import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { DataMaterialsService } from '@components/materials/data-materials.service';

@Component({
  selector: 'app-orders-materials',
  templateUrl: './orders-materials.component.html',
  styleUrls: ['./orders-materials.component.less']
})
export class OrdersMaterialsComponent implements OnInit {
  public projectRooms:any = [];

  // loading
  public isLoaded:boolean = false;

  // NUmber Materials
  public stateMaterials = {
    total: 0,
    inDelivery : 0,
    delivered: 0
  };

  // Detect with and height for mobile
  public screenHeight: number;
  public screenWidth: number;

  constructor(
    public dataMaterialsService: DataMaterialsService,
    public router: Router
  ) {  this.getScreenSize(); }

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  async ngOnInit() {
    this.isLoaded = false;

    const projectRooms = _.cloneDeep(this.dataMaterialsService.projectRooms);

    await this.dataMaterialsService.computeProjectMaterialsData();

    const projectMaterials = this.dataMaterialsService.getProjectMaterials();

    this.stateMaterials = OrdersMaterialsComponent.checkStateMats(projectMaterials.items);
    this.projectRooms = this.formatProjectRoomsWithMat(projectRooms, projectMaterials.items);

    if (this.screenWidth < 767) {
      const wrapperSidebar = document.getElementById('sidebar');
      wrapperSidebar.style.display = 'none';
    }

    this.isLoaded = true;
  }

  private static checkStateMats = projMat => ({
    total: projMat.length,
    inDelivery: projMat.filter(mat => mat.state === 'CMD').length,
    delivered: projMat.filter(mat => mat.state === 'delivered').length
  })

  public formatProjectRoomsWithMat(projectRooms, projectMaterials) {
    const pr = projectRooms.map((r) => {
      const projectRoom = { ...r };

      projectRoom.project_materials = projectRoom.materials.map((mat) => {
        if (['validation_lw', 'validation_by_signature'].includes(mat.status)) {
          return projectMaterials.find(m => m.id_material_version === mat.version.id);
        }

        return null;
      }).filter(i => i);

      return projectRoom;
    }).filter(r => r.project_materials.length > 0);

    return pr.map((r) => {
      r.project_materials.map((pm) => {
        pm.mainImg = (pm._related.material_version_images.length > 0
          && pm._related.material_version_images[0] !== null
          && pm._related.material_version_images[0].id_image !== null)
          ? this.dataMaterialsService
            .getSafeStyleImgURL(pm._related.material_version_images[0].id_image, 'small')
          : '/assets/images/placeholder-img.png';

        return pm;
      });

      return r;
    });
  }

  public calcMatDelivered(materials) {
    return materials.filter(mat => mat.state === 'delivered').length;
  }
}
